import * as React from 'react';
import { Box } from 'wix-style-react';
import { useLocation } from 'react-router-dom';
import window from 'global';
import { contactOwnerLickClicked } from '../../../../../../../LoggerFactory/BiAnalyticsLogger/events';
import { getArticleNameFromPathname } from '../../../../../../../LoggerFactory/BiAnalyticsLogger/events/utils';
import { LoggerContext } from '../../../../../../../appContext/LoggerProvider';
import { StoreContext } from '../../../../../../../appContext/StoreProvider';
import { LOGGER_TYPES } from '../../../../../../../LoggerFactory/loggerTypes';
import { Text } from '../../../../../../PageElements/Text';
import { ExternalLink } from '../../../../../../PageElements/ExternalLink';
import { JiraIcon, SlackIcon } from '../../../../../../PageElements/svgs';
import { getJiraProjectLink } from './utils';

export const ArtifactDataHelper = ({
  slackChannels = {},
  jiraProjects,
  company,
}) => {
  const artifactDataError = () => (
    <Box direction="vertical">
      <Box dataHook="artifact-data-error" marginBottom="6px">
        <Text size="small" weight="bold" tagName="span">
          Oops...
        </Text>
      </Box>
      <Text size="small" weight="normal" tagName="span">
        Unfortunately, we can't find the owner information for this API
      </Text>
    </Box>
  );

  const Row = ({
    icon,
    propName,
    propValueText,
    propValueHref,
    linkDataHook,
    marginBottom = '0px',
  }) => {
    const location = useLocation();
    const { logger } = React.useContext(LoggerContext);
    const { store } = React.useContext(StoreContext);
    const article_url = window.location.href;

    const sendLinkClickedContactOwnerBiEvent = (link_type) => {
      const article_name = getArticleNameFromPathname(location.pathname, store);
      logger.getLogger(LOGGER_TYPES.ANALYTICS_BI).log(contactOwnerLickClicked, {
        article_name,
        article_url,
        link_type,
      });
    };
    const NotAvailable = () => (
      <Text
        tagName="span"
        weight="normal"
        size="small"
        dataHook="not-available"
      >
        Not Available
      </Text>
    );
    const IconBox = () => <Box marginRight="4px">{icon}</Box>;
    return (
      <Box alignment="space-between" marginBottom={marginBottom}>
        <Box marginRight="18px" width="102px">
          <IconBox />
          <Text size="small" tagName="span">
            {propName}
          </Text>
        </Box>
        {propValueHref ? (
          <Box width="264px">
            <ExternalLink
              onClick={() => sendLinkClickedContactOwnerBiEvent(propName)}
              size="small"
              weight="normal"
              dataHook={linkDataHook}
              to={propValueHref}
              ellipsis
            >
              {propValueText}
            </ExternalLink>
          </Box>
        ) : (
          <NotAvailable />
        )}
      </Box>
    );
  };

  const artifactDataView = () => {
    if (!slackChannels.main || !slackChannels.urgent) {
      return artifactDataError();
    }
    const jiraProjectLink = getJiraProjectLink(jiraProjects);
    return (
      <React.Fragment>
        <Box marginBottom="9px">
          <Text size="small" weight="bold" tagName="span">
            Owned by: {company}
          </Text>
        </Box>

        <Row
          icon={<SlackIcon />}
          propName="Main Slack"
          propValueHref={
            slackChannels.main
              ? `https://wix.slack.com/messages/${slackChannels.main}`
              : ''
          }
          propValueText={`#${slackChannels.main}`}
          linkDataHook="artifact-slack-main-text"
          marginBottom="6px"
        />

        <Row
          icon={<SlackIcon />}
          propName="Urgent Slack"
          propValueHref={
            slackChannels.urgent
              ? `https://wix.slack.com/messages/${slackChannels.urgent}`
              : ''
          }
          propValueText={`#${slackChannels.urgent}`}
          linkDataHook="artifact-slack-urgent-text"
          marginBottom="6px"
        />

        <Row
          icon={<JiraIcon />}
          propName="Jira Project"
          propValueHref={jiraProjectLink}
          propValueText={jiraProjectLink}
          linkDataHook="artifact-jira-text"
        />
      </React.Fragment>
    );
  };

  return artifactDataView();
};
